import "./About.module.css";
import Header from "@/reusable_sections/Header";
import MeetTheHandsThatShape from "./sections/MeetTheHandsThatShape";
import MySuperLetter from "./sections/MySuperLetter";
import OurPrinciplesAndValues from "./sections/OurPrinciplesAndValues";
import AboutMe from "./sections/AboutMe";
import Features from "./sections/Features";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <MeetTheHandsThatShape />
      <MySuperLetter />
      <OurPrinciplesAndValues />
      <AboutMe />
      <Features />
      <Footer />
    </div>;
}